import { render, staticRenderFns } from "./MallRentMainPageNeimeng.vue?vue&type=template&id=2a7dcdf2&scoped=true"
import script from "./MallRentMainPageNeimeng.vue?vue&type=script&lang=js"
export * from "./MallRentMainPageNeimeng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7dcdf2",
  null
  
)

export default component.exports